module.exports = __webpack_public_path__ + "img/mail-circle.83fb2944.png";